import { entityType } from "./module";
import { createGetMethod } from "reactcoregk/store/actions";
import { getDefaultApiHandler } from "../../helpers/utils";

export const getCurrentUserInfo = (params) =>
  createGetMethod(entityType, params, getDefaultApiHandler());
